// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// third party
import { FormattedMessage } from 'react-intl';

export default function Footer() {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'center', pt: 3, mt: 'auto' }}>
      <Typography variant="caption" color="text.secondary">
        <FormattedMessage
          id="footer.copyright"
          defaultMessage="© {year} ready2mice"
          values={{ year: new Date().getFullYear() }}
        />
      </Typography>
    </Stack>
  );
}
